import { Car, Client } from '../components/agenda/agenda.types';
import { ITranslation } from '../interfaces/IReferential';
import { Organization } from '../interfaces/Organization';

export type AppointmentStatusType = {
  code: string;
  name: string;
  id: number;
  translations: ITranslation[];
};

export type AppointmentHistoryType = {
  date: string;
  appointmentStatusId: number;
  userId: string;
  user?: any;
  appointmentStatus?: AppointmentStatusType;
  comment: string;
};

export type AppointmentFiltersPayloadType = {
  appointmentIds: string[];
  services: Organization[];
  formatedDateList: string[];
  formatedHourList: string[];
  makeList: string[];
  modelList: string[];
  plateNumberList: string[];
  formattedDateCreationList: string[];
  formattedHourCreationList: string[];
  appointmentStatuses: AppointmentStatusType[];
  appAppointmentIds: number[];
  appointmentCategoryTypes: AppointmentCategoryType[];
};

export type AppointmentCategoryType = {
  code: string;
  name: string;
  id: number;
  translations: ITranslation[];
};

export type AppointmentType = {
  id: number;
  appAppointmentId?: number;
  id_service: number;
  id_user: number;
  id_car: number;
  nr_km: number;
  type: string;
  datetime: string;
  confirmation: boolean;
  status: number;
  created_at: string;
  updated_at: string;
  reschedule: string;
  final: string;
  schedule_rem: number;
  schedule_notif: number;
  cancel: string;
  callresch: number;
  final_date_time: string;
  obs: string;
  contactp: string;
  date: string;
  appointmentStatus?: AppointmentStatusType;
  appointmentClient?: Client;
  contactClient?: Client;
  vehicle: Car;
  appointmentJobTypes: Option[];
  jobDetails?: string;
  appEmail?: string;
  appFirstName?: string;
  appLastName?: string;
  appPhone?: string;
  appUsername?: string;
  appointmentStatusHistories?: AppointmentHistoryType[];
  caseId?: number;
  appointmentStatusId?: number;
  appointmentClientSelections: AppointmentClientSelection[];
  serviceId: number;
  service: Organization | null;
  parentId?: number;
  appointmentCategoryType: AppointmentCategoryType;
  hideCancelButton: boolean;
  vehicleId: number | null;
  driverId: string | null;
  partnerOrganizationId: number | null;
  appName: string;
};

export interface Option {
  name: string;
  id: number;
  jobTypeId?: number;
  translations: ITranslation[];
}
export type AppointmentsFiltersType = {
  dateFilterStartDate?: string;
  datefilterEndDate?: string;
  text?: string;
  page?: number;
  pageSize?: number;
  formatedDateList?: string;
  includedAdditionalData?: boolean;
  viewPartnerAppointments?: boolean;
  organizationOwnerId?: number | null;
  serviceIds?: number[];
};

export type ResponseAppointmentsData = {
  appointments: AppointmentType[];
  page: number;
  total: number;
};

export type CarRequestType = {
  vin: string | null;
  firstPlateDate: string | null;
  plateNumber: string | null;
  numberOfKilometers: string | null;
  model: string | null;
  make: string | null;
};

export type AppointmentRequestPayload = {
  serviceId?: number;
  appointmentClient?: Client | null;
  vehicle: CarRequestType;
  date: string;
  appointmentJobTypes?: Array<{ id: number; name: string }>;
  jobDetails?: string;
  appFirstName: string;
  appLastName: string;
  appEmail: string;
  appPhone: string;
  appUsername: string;
  inAppointment?: boolean;
  appointmentCategoryTypeId: number;
  parentId?: number;
  workflowId?: number;
  caseId?: number;
  vehicleId: number | null;
  driverId: string | null;
  partnerOrganizationId: number | null;
};

export type AppointmentForOrganizationRequestDto = {
  appointmentId: number;
  organizationOwnerId?: number | null;
};

export type ChangeAppointmentStatusPayload = {
  appointmentId: number;
  statusId: number;
  date?: string;
  appointmentClientSelectionId?: number;
  comment?: string;
};

export interface AppointmentClientSelection {
  id: number;
  appointmentId: number;
  date: string;
  isSelected: boolean;
  isClientSelection: boolean;
}

export enum AppointmentFilterStateKeys {
  appointmentIds = 0,
  services = 1,
  formattedDateCreationList = 2,
  formattedHourCreationList = 3,
  makeList = 4,
  modelList = 5,
  plateNumberList = 6,
  formatedDateList = 7,
  formatedHourList = 8,
  appointmentStatuses = 9,
  appAppointmentIds = 10,
  appointmentCategoryTypes = 11
}

export enum AppointmentTableColumns {
  'id' = 'appointmentIds',
  'service.name' = 'services',
  'vehicle.model.brand' = 'makeList',
  'vehicle.model.name' = 'modelList',
  'vehicle.plateNumber' = 'plateNumberList',
  'appointmentStatus' = 'appointmentStatuses',
  'appAppointmentId' = 'appAppointmentIds',
  'appointmentCategoryType' = 'appointmentCategoryTypes'
}
